import { createSlice } from '@reduxjs/toolkit'

export const systemAnnouncementSlice = createSlice({
  name: 'systemannouncement_popup',
  initialState: {
    value: false,
  },
  reducers: {
    setSystemAnnouncementsShown: (state , action) => {
  
        state.value = action.payload;
      
      },
  },
});

export const { setSystemAnnouncementsShown } = systemAnnouncementSlice.actions;

export default systemAnnouncementSlice.reducer;
